import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SearchHistoryTable from './SearchHistoryTable.jsx';
import {
  useGetSearchHistoryQuery,
  useLazyGetSearchHistoryCsvQuery,
} from '../../../../../redux/services/search_history.jsx';
import { CollapseBlock, Spinner } from '../../../../common/index.jsx';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { FileExcelOutlined } from '@ant-design/icons';

const SearchHistoryPage = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetSearchHistoryQuery({
    view: 'searchHistoryTable',
  });
  const [triggerDownloadCsv, { data: csvData }] =
    useLazyGetSearchHistoryCsvQuery();

  const mainActions = [
    {
      permission: 'search-history.index',
      onClick: () => triggerDownloadCsv(),
      title: t('Exportovať históriu'),
      icon: <FileExcelOutlined />,
    },
  ];

  useEffect(() => {
    document.title = t('História vyhľadávania') + ' - FRI CMS';
  }, []); // Runs on mount

  useEffect(() => {
    if (csvData) {
      if (csvData.blob instanceof Blob) {
        const url = window.URL.createObjectURL(csvData.blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'search_history.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return;
      }

      if (typeof csvData.excel !== 'string' || csvData.excel.length === 0) {
        return;
      }

      const byteCharacters = atob(csvData.excel);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'search_history.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }, [csvData]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('História vyhľadávania')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'search-history'}
        mainActions={mainActions}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('História vyhľadávania')}>
          <SearchHistoryTable searchHistory={data} />
        </CollapseBlock>
      </div>
    </>
  );
};

export default SearchHistoryPage;
